import { useState, useEffect } from "react";

// Custom hook to determine if the screen is mobile
export default function useIsMobileFooter(length) {
  const length1 = length ? length : 37.5 * 16;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= length1);

  useEffect(() => {
    // Event listener for window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= length1);
    };

    // Add event listener for window resize when the component mounts
    window.addEventListener("resize", handleResize);

    // Remove event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
}
